import {SET_CART_STATUS} from '../actions/types';

export default (state='ready',action)=>{
    switch(action.type){
        case SET_CART_STATUS:
            return action.payload;
        default:
            return state;
    }
}